module.exports = __webpack_public_path__ + "static/media/warning-modal.79faf962.svg";